import { gql } from "@apollo/client";
import { customizations, layoutQuery } from "./Query.Base";

export const GET_PARAGRAPH_WIDGET = (name: string) => {
  return (
    gql`
      query getParagraphWidget($contentItemId: ID!) {
        ${name}(where: {contentItemId: $contentItemId}) {
          content {
            contentItems {
              __typename
              ... on ParagraphWidget {
                contentItemId
                contentType
                displayText
                text {
                  html
                }
                ${customizations}
              }
            }
          }
        }
      }
    `
  )
}

export const GET_VIDEO_WIDGET = (name: string) => {
  return (
    gql`
      query getVideoWidget($contentItemId: ID!) {
        ${name}(where: {contentItemId: $contentItemId}) {
          content {
            contentItems {
              __typename
              ... on VideoWidget {
                contentItemId
                contentType
                displayText
                cover {
                  paths
                }
                sources {
                  paths
                }
                description {
                  html
                }
                ${customizations}
              }
            }
          }
        }
      }
    `
  )
}

export const GET_FILE_WIDGET = (name: string) => {
  return (
    gql`
      query getFileWidget($contentItemId: ID!) {
        ${name}(where: {contentItemId: $contentItemId}) {
          content {
            contentItems {
              __typename
              ... on FileWidget {
                contentItemId
                contentType
                displayText
                files {
                  paths
                  texts
                }
                ${customizations}
              }
            }
          }
        }
      }
    `
  )
}

export const GET_IMAGE_GALLERY_WIDGET = (name: string) => {
  return (
    gql`
      query getImageGalleryWidget($contentItemId: ID!) {
        ${name}(where: {contentItemId: $contentItemId}) {
          content {
            contentItems {
              __typename
              ... on ImageGalleryWidget {
                contentItemId
                contentType
                displayText
                style
                textMode
                images {
                  paths
                  texts
                }
                ${layoutQuery}
                ${customizations}
              }
            }
          }
        }
      }
    `
  )
}

export const GET_ITINERARY_WIDGET = (name: string) => {
  return (
    gql`
      query getItineraryWidget($contentItemId: ID!) {
        ${name}(where: {contentItemId: $contentItemId}) {
          content {
            contentItems {
              __typename
              ... on ItineraryWidget {
                contentItemId
                contentType
                displayText
                activities {
                  contentItems {
                    displayText
                    __typename
                    ... on ItineraryActivity {
                      activity
                      icon
                      day
                      startTime
                      endTime
                      brief {
                        html
                      }
                      gallery {
                        paths
                      }
                      location {
                        latitude
                        longitude
                      }
                    }
                  }
                }
                ${customizations}
              }
            }
          }
        }
      }
    `
  )
}

export const GET_SLIDESHOW_WIDGET = (name: string) => {
  return (
    gql`
      query getSlideshowWidget($contentItemId: ID!) {
        ${name}(where: {contentItemId: $contentItemId}) {
          content {
            contentItems {
              __typename
              ... on SlideshowWidget {
                contentItemId
                contentType
                displayText
                autoDisplay
                animation
                progressBar
                backgroundMode
                slides {
                  contentItems {
                    contentItemId
                    displayText
                    __typename
                    ... on SlideshowItem {
                      contentType
                      flip
                      positionX
                      media {
                        paths
                        texts
                      }
                      textOverly {
                        html
                      }
                      navigation {
                        text
                        url
                      }
                    }
                  }
                }
                ${customizations}
              }
            }
          }
        }
      }
    `
  )
}

export const GET_MAP_WIDGET = (name: string) => {
  return (
    gql`
      query getMapWidget($contentItemId: ID!) {
        ${name}(where: {contentItemId: $contentItemId}) {
          content {
            contentItems {
              __typename
              ... on MapWidget {
                contentItemId
                displayText
                dataSource
                contentType
                provider
                style
                zoom
                zoomEnable
                center {
                  latitude
                  longitude
                }
                layers {
                  contentItems{
                    __typename
                    ... on MapLayer{
                      overlies {
                        contentItems{
                          __typename
                          ... on MapPolygon{
                            contentItemId
                            stroke
                            strokeWidth
                            strokeOpacity
                            fill
                            fillOpacity
                            invert
                            points
                          }
                        }
                      }
                    }
                  }
                }
                ${customizations}
              }
            }
          }
        }
      }
    `
  )
}

export const GET_CARD_WIDGET = (name: string) => {
  return (
    gql`
      query getCardWidget($contentItemId: ID!) {
        ${name}(where: {contentItemId: $contentItemId}) {
          content {
            contentItems {
              __typename
              ... on CardWidget {
                contentItemId
                contentType
                displayText
                style
                items {
                  contentItems {
                    __typename
                    ... on CardItem {
                      displayText
                      description
                      link
                      image {
                        paths
                      }
                    }
                  }
                }
                ${layoutQuery}
                ${customizations}
              }
            }
          }
        }
      }
    `
  )
}

export const GET_COMPONENT_WIDGET = (name: string) => {
  return (
    gql`
      query getCardWidget($contentItemId: ID!) {
        ${name}(where: {contentItemId: $contentItemId}) {
          content {
            contentItems {
              __typename
              ... on ComponentWidget {
                contentItemId
                contentType
                displayText
                componet
                parameters {
                  contentItems {
                    ... on KeyValue {
                      key
                      value
                    }
                  }
                }
                ${customizations}
              }
            }
          }
        }
      }
    `
  )
}


export const GET_BANNER_WIDGET = (name: string) => {
  return (
    gql`
      query getBannerWidget($contentItemId: ID!) {
        ${name}(where: {contentItemId: $contentItemId}) {
          content {
            contentItems {
              __typename
              ... on BannerWidget {
                contentItemId
                contentType
                displayText
                wrap
                size
                subtitle
                description
                image {
                  paths
                  texts
                }
                color
                navigation {
                  text
                  url
                }
                ${customizations}
              }
            }
          }
        }
      }
    `
  )
}